
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.643","cy":"14.643","r":"14.643","transform":"matrix(-1 0 0 1 32.34 2.715)","fill":"#ECEFF1"}}),_c('circle',{attrs:{"cx":"7.529","cy":"7.529","r":"7.529","transform":"matrix(-1 0 0 1 25.277 9.825)","fill":"#85C4EE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.547 5.064a.65.65 0 00-.65.65V9.63a.65.65 0 001.3 0V6.364h3.266a.65.65 0 000-1.3h-3.916z","fill":"#455A64"}}),_c('path',{attrs:{"d":"M16.95 1.39a.63.63 0 00-.653-.638C7.774 1.114.976 8.138.976 16.75c0 8.843 7.169 16.012 16.012 16.012S33 25.593 33 16.75c0-4.089-1.532-7.82-4.054-10.65h-1.807A14.67 14.67 0 0131.7 16.75c0 8.125-6.587 14.712-14.712 14.712S2.276 24.875 2.276 16.75c0-7.895 6.218-14.338 14.025-14.697a.673.673 0 00.648-.664z","fill":"#455A64"}}),_c('path',{attrs:{"stroke":"#455A64","stroke-width":"1.3","stroke-linecap":"round","d":"M17.018 8.114v8.589"}}),_c('path',{attrs:{"d":"M13.667 9.65c0-.48-.488-.805-.909-.572a8.76 8.76 0 108.493.019c-.42-.236-.91.089-.91.57 0 .256.145.488.366.616a7.46 7.46 0 11-7.41-.016.715.715 0 00.37-.617z","fill":"#455A64"}})])
          )
        }
      }
    